export enum Status {
    ATTIVO = 'Attivo',
    DISATTIVO = 'Disattivo'
}
